import _ from "lodash";
import React from "react";
import { connect } from "react-redux";
import { Modal } from "react-bootstrap";
import Button from "react-bootstrap-button-loader";
import { reduxForm } from "redux-form";
import { showSuccess } from "ReduxErrorBar";
import LocaleStrings from "Languages";
import { BaseComponent } from "BaseComponent";
import { converDateIntoLocalwithmonth, MAIN_URL } from "Constants";
import renderHTML from "react-render-html";

class ViewBillingHistorydetails extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      btnLoading: false,
    };
  }
  closeModals = () => {
    this.props.onClose();
  };

  renderList = (e) => {
    let { row_data } = this.props;
    let item = _.map(
      row_data.clientinvoiceitems_by_invoiceidfk,
      (data, index) => {
        var descriptionData = "";
        if (data.descriptiontext) {
          descriptionData = data.descriptiontext.replaceAll("\n", "<br/>");
        }
        return (
          <>
            <tr key={index} id={index}>
              <td className="td4">
                <div className="" style={{ fontWeight: 700 }}>
                  {data.itemname}
                </div>
                <div className="">{renderHTML(descriptionData)}</div>
              </td>
              <td className="td3">
                {" "}
                <div className="ml-10"> {data.quantity} </div>
              </td>
              <td className="td3">
                {" "}
                <div className="ml-10"> {data.price} </div>
              </td>
              <td className="td3">
                {" "}
                <div className="ml-10"> ${data.total}</div>
              </td>
            </tr>
            {data.discountpercentage !== 0 &&
            data.discountpercentage !== null ? (
              <tr key={index} id={index}>
                <td className="td4">
                  <div className="" style={{ fontWeight: 700 }}>
                    {data.discounttext !== null ? data.discounttext : ""}
                  </div>
                </td>
                <td className="td3">
                  {" "}
                  <div className="ml-10"> </div>
                </td>
                <td className="td3">
                  {" "}
                  <div className="ml-10">
                    {
                      LocaleStrings.accountsetting_billing_details_table_viewbillmodaldiscountedprice
                    }{" "}
                    ({data.discountpercentage}%)
                  </div>
                </td>
                <td className="td3">
                  {" "}
                  <div className="ml-10">
                    -${parseFloat(data.discountamount)}
                  </div>
                </td>
              </tr>
            ) : (
              ""
            )}
          </>
        );
      }
    );
    return item;
  };

  fetchURLs(message) {
    var urlRegex = /(((https?:\/\/)|(www\.))[^\s]+)/g;
    return message.match(urlRegex);
  }

  copyItems = (e, value) => {
    // console.log("value", value);
    navigator.clipboard.writeText(value);
    this.props.showSuccess("Successfully Copied");
  };

  render() {
    let { row_data, clientdataforbilling } = this.props;
    let tabledate = "";
    let location = "";
    let validupto = "";
    let plantype = "";
    let usercredit = "";
    let openpaymentLink = MAIN_URL + "/billingpayment?" + row_data.id;

    tabledate = converDateIntoLocalwithmonth(row_data.createdon).format(
      "D MMM YYYY"
    );
    if (row_data?.validitytill != "" && row_data?.validitytill != null) {
      validupto = converDateIntoLocalwithmonth(row_data?.validitytill).format(
        "D MMM YYYY"
      );
    }

    var contentData = "";
    if (row_data.terms) {
      contentData = row_data.terms.replaceAll("\n", "<br/>");
      usercredit = row_data.userlimit;
    }

    if (row_data.plantype) {
      plantype = row_data.plantype;
    }

    if (
      row_data.clients_by_clientid.address !== null &&
      row_data.clients_by_clientid.address !== ""
    ) {
      location = row_data.clients_by_clientid.address;
    }

    if (
      row_data.clients_by_clientid.state !== null &&
      row_data.clients_by_clientid.state !== ""
    ) {
      location = location + "-";
      location = location + row_data.clients_by_clientid.state;
    }
    if (
      row_data.clients_by_clientid.city !== null &&
      row_data.clients_by_clientid.city !== ""
    ) {
      location = location + "-";
      location = location + row_data.clients_by_clientid.city;
    }
    if (
      row_data.clients_by_clientid.zipcode !== null &&
      row_data.clients_by_clientid.zipcode !== ""
    ) {
      location = location + "-";
      location = location + row_data.clients_by_clientid.zipcode;
    }

    let content1 = contentData;
    // if (contentData != "") {
    //   let detectURLs = this.fetchURLs(contentData);

    //   if (detectURLs !== null && detectURLs.length > 0) {
    //     _.forEach(detectURLs, (v, i) => {
    //       let a_tag = `<a href=${v} target="_blank">${v}</a>`;
    //       content1 = content1.replace(v, a_tag);
    //     });
    //   }
    // }

    let client_address = "";
    let client_companyname = "";
    let vat_number = "";
    if (
      row_data.client_address &&
      row_data.client_address != null &&
      row_data.client_address != ""
    ) {
      client_address = row_data.client_address;
    }
    if (
      row_data.client_companyname &&
      row_data.client_companyname != null &&
      row_data.client_companyname != ""
    ) {
      client_companyname = row_data.client_companyname;
    }
    if (
      row_data.vat_number &&
      row_data.vat_number != null &&
      row_data.vat_number != ""
    ) {
      vat_number = row_data.vat_number;
    }

    return (
      <Modal
        show={this.props.isOpen}
        onHide={this.closeModals}
        className=""
        dialogClassName="contact-eventify-modal"
      >
        <Modal.Header>
          <Modal.Title>
            <div className="title-modal">
              {
                LocaleStrings.accountsetting_billing_details_table_viewbillmodalhead
              }
            </div>
          </Modal.Title>
          <button
            type="button"
            className="i-custom-cross-popup pull-right"
            onClick={this.closeModals}
          >
            <img
              className="i-custom-small"
              src="../../style/images/custom-icons/cross-black.png"
            />
          </button>
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex">
            <div className="mt-4">
              <div className="custom-text1-primary-medium2">
                {_.startCase(row_data.type)}
              </div>
              <div className="custom-text1-gray">
                {" "}
                {_.startCase(row_data.type)}: {row_data.id}
              </div>
              <div className="custom-text1-gray">
                {LocaleStrings.accountsetting_billing_details_issued_on}{" "}
                {tabledate}
              </div>
            </div>
            <div className="ms-auto d-flex">
              <img
                className="eventify-logo"
                src="../../style/images/eventify-logo.png"
              />
              <div className="align-self-center custom-text1-primary-medium">
                {LocaleStrings.by}
              </div>
              <img
                className="teks-logo-"
                src="../../style/images/Teks-logo-color.png"
              />
            </div>
          </div>

          <div className="d-flex detail-subheader">
            <div className="detail-subheader-box">
              <div className="custom-text1-primary-medium">
                {
                  LocaleStrings.accountsetting_billingdetails_subheader_box1_plantype
                }
              </div>
              <div className="custom-text1-gray">{_.startCase(plantype)}</div>
              <div className="custom-text1-primary-medium mt-2">
                {" "}
                {
                  LocaleStrings.accountsetting_billingdetails_subheader_total_user_limit
                }
              </div>
              <div className="custom-text1-gray">{usercredit}</div>
              {validupto != "" ? (
                <>
                  <div className="custom-text1-primary-medium mt-2">
                    {" "}
                    {LocaleStrings.accountsetting_billing_details_validitytill}
                  </div>
                  <div className="custom-text1-gray">{validupto}</div>
                </>
              ) : (
                ""
              )}
            </div>
            <div className="detail-subheader-box">
              <div className="custom-text1-primary-medium">
                {LocaleStrings.accountsetting_billingdetails_billed_to}
              </div>
              <div className="custom-text1-gray"> {row_data.clientname}</div>
              <div className="custom-text1-gray"> {row_data.clientemail}</div>
              <div className="custom-text1-gray">{client_address}</div>
              {client_companyname != "" ? (
                <div className="custom-text1-gray">
                  {
                    LocaleStrings.accountsetting_billingdetails_subheader_box1_company
                  }{" "}
                  {client_companyname}
                </div>
              ) : (
                ""
              )}
              {vat_number != "" ? (
                <div className="custom-text1-gray">
                  {
                    LocaleStrings.accountsetting_billingdetails_subheader_box1_vatnumber
                  }
                  {vat_number}
                </div>
              ) : (
                ""
              )}
            </div>
            <div className="p-20">
              <div className="custom-text1-gray">
                {
                  LocaleStrings.accountsetting_billing_details_table_viewbillmodalhead_teksaddress1
                }
              </div>
              <div className="custom-text1-gray">
                {
                  LocaleStrings.accountsetting_billing_details_table_viewbillmodalhead_teksaddress2
                }
              </div>
              <div className="custom-text1-gray">
                {
                  LocaleStrings.accountsetting_billing_details_table_viewbillmodalhead_teksaddress3
                }
              </div>
            </div>
          </div>

          {row_data && row_data.clientinvoiceitems_by_invoiceidfk.length > 0 ? (
            <>
              <div className="mt-5">
                <table className="table">
                  <thead>
                    <tr>
                      <th align="center">
                        {
                          LocaleStrings.accountsetting_billing_details_table_viewbillmodalhead_th1
                        }
                      </th>
                      <th align="center">
                        {
                          LocaleStrings.accountsetting_billing_details_table_viewbillmodalhead_th2
                        }
                      </th>
                      <th align="center">
                        {
                          LocaleStrings.accountsetting_billing_details_table_viewbillmodalhead_th5
                        }
                      </th>
                      <th align="center">
                        {
                          LocaleStrings.accountsetting_billing_details_table_viewbillmodalhead_th4
                        }
                      </th>
                    </tr>
                  </thead>
                  <tbody className="tbody-background">
                    {this.renderList()}
                  </tbody>
                </table>
              </div>
              <div
                className="custom-text1-primary-medium text-end"
                style={{ marginLeft: "auto" }}
              >
                <div className="" style={{ marginRight: "11%" }}>
                  {
                    LocaleStrings.accountsetting_billing_details_table_viewbillmodalhead_grandtotal
                  }{" "}
                  ${row_data.total_amount.toFixed(2)}
                </div>
              </div>
            </>
          ) : (
            ""
          )}
          <div className="row">
            <div className="col-md-8">
              <div className="mt-5 custom-text1-primary-medium">
                {
                  LocaleStrings.accountsetting_billing_details_table_viewbillmodalhead_thankyou
                }
              </div>
              <div className="mt-2 custom-text1-primary-medium">
                {
                  LocaleStrings.accountsetting_billing_details_table_viewbillmodalhead_terms
                }
              </div>
              <div className="mt-2 custom-text1-primary-medium">
                {renderHTML(content1)}
              </div>
            </div>
            <div className="col-md-4">
              {row_data.type == "quote" && row_data.status == "unpaid" ? (
                <div className="mt-60">
                  {
                    LocaleStrings.accountsetting_billing_details_table_viewbillmodalhead_openlink
                  }
                  <a href={openpaymentLink}>
                    {" "}
                    {
                      LocaleStrings.accountsetting_billing_details_table_viewbillmodalhead_payhere
                    }
                  </a>
                  <img
                    onClick={(e) => this.copyItems(e, openpaymentLink)}
                    className="ml-2 cursor-pointer"
                    src="../../style/images/copy-icon.png"
                    style={{ width: "15px", height: "15px" }}
                  ></img>
                </div>
              ) : row_data.status == "cancelled" ? (
                <div className="mt-60 text-danger">
                  {
                    LocaleStrings.accountsetting_billing_details_table_viewbillmodalhead_quote_cancelled
                  }
                </div>
              ) : row_data.status == "paid" ? (
                <div className="mt-60 text-danger">
                  {
                    LocaleStrings.accountsetting_billing_details_table_viewbillmodalhead_quote_payment_received
                  }
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
          <div className="viewbilling_lastsection">
            <div className="mt-5 custom-text1-primary-medium">
              {LocaleStrings.accountsetting_billing_details_table_viewmodal_tq}
            </div>
            <div className="custom-text1-gray mt-2">
              {LocaleStrings.accountsetting_billing_details_table_viewmodal_tq1}
            </div>
          </div>
          <div className="d-flex mt-2">
            <div className="custom-text1-gray" style={{ width: "50%" }}>
              {
                LocaleStrings.accountsetting_billing_details_table_viewmodal_eventifysite
              }
            </div>
            <div className="ms-auto">
              <div className="d-flex">
                <div className="custom-text1-gray ml-2">
                  {
                    LocaleStrings.accountsetting_billing_details_table_viewbillmodalhead_eventifyemail
                  }
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div>
            <div className="pull-left h-100 vertical-align-center"></div>
            <div
              className="pull-right h-100 vertical-align-center"
              style={{ marginLeft: "auto" }}
            >
              <Button variant="secondary" onClick={this.closeModals}>
                {LocaleStrings.button_close}
              </Button>
            </div>
          </div>
        </Modal.Footer>
      </Modal>
    );
  }
}
function mapStateToProps(state, ownProps) {
  return {
    session: state.session,
    clientdataforbilling: state.clientdataforbilling,
    client_historydata: state.client_historydata,
    row_data: ownProps.data,
  };
}
export default connect(mapStateToProps, { showSuccess })(
  reduxForm({
    form: "ViewBillingHistorydetailsModalForm",
    enableReinitialize: true,
    keepDirtyOnReinitialize: true,
  })(ViewBillingHistorydetails)
);
